import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {ButtonModule} from '@ucx/ui-cmp';
import {NgxStripeModule} from 'ngx-stripe';
import {ConfirmModalModule} from '../../../shared/modules/confirm-modal/confirm-modal.module';
import {StripeAddBankAccountComponent} from './stripe-add-bank-account.component';

@NgModule({
  declarations: [
    StripeAddBankAccountComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    ButtonModule,
    NgxStripeModule,
    ConfirmModalModule
  ],
  exports: [
    StripeAddBankAccountComponent
  ]
})
export class StripeAddBankAccountModule {
}
